// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2-1BF","author":"Table_author__3jBDp","authorImage":"Table_authorImage__14YPh","unreadRow":"Table_unreadRow__LEhcv"};